import { SIZE_COLUMN_FIELD, UPC_COLUMN_FIELD } from "helpers/utils/constants";
import { ValidatorChainBuilder } from "helpers/validator";

import { IIdentifierFields, IUPCData, IUPCDataError, ProductList } from "./types";
import {
    NotEmptyRule,
    ProductIdentifierMatchRule,
    RequiredColumnsRule,
    RequiredValuesRule,
    UPCNumericRule,
    UPCScientificRule,
} from "./validation-rules";

const requiredColumnsForUploadFileSheet = [UPC_COLUMN_FIELD, SIZE_COLUMN_FIELD];
const requiredValuesForUploadFileSheet = [SIZE_COLUMN_FIELD];

type GetUPCValidatorProps = {
    products: ProductList;
    identifierFields?: IIdentifierFields[];
};

const getUPCValidator = ({ products, identifierFields = [] }: GetUPCValidatorProps) => {
    const requiredColumns = [...requiredColumnsForUploadFileSheet, ...identifierFields];
    const requiredValues = [...requiredValuesForUploadFileSheet, ...identifierFields];

    const validatorChain = new ValidatorChainBuilder<IUPCData[], IUPCDataError>()
        .add(new NotEmptyRule())
        .add(new RequiredColumnsRule(requiredColumns))
        .add(new RequiredValuesRule(requiredValues, identifierFields))
        .add(new UPCNumericRule(identifierFields))
        .add(new UPCScientificRule(identifierFields))
        .add(new ProductIdentifierMatchRule(products, identifierFields));

    return validatorChain.getFirst();
};

type ValidateUPCDataProps = {
    data: IUPCData[];
    products: ProductList;
    identifierFields?: IIdentifierFields[];
};

export const validateUPCData = ({ data, products, identifierFields }: ValidateUPCDataProps): IUPCDataError => {
    const UPCValidator = getUPCValidator({ products, identifierFields });
    return UPCValidator.validate(data, {});
};
